import Dropdown from "../Dropdown/Dropdown";
import moment from "moment";
import tuttiComuni from "../../Utility/json/tuttiComuni.js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Card = (props) => {
    const card = props.card;
    const deleteFunction = props.deleteFunction;
    const renounceFunction = props.renounceFunction;
    const editFunction = props.editFunction;
    const aggiornaFunction = props.aggiornaFunction;
    const secondoAccessoFunction = props.secondoAccessoFunction;
    const terzoAccessoFunction = props.terzoAccessoFunction;
    const pdfFunction = props.pdfFunction;
    const rejectFunction = props.rejectFunction;
    const iseeKoBtnFunction = props.iseeKoBtnFunction;
    const showMotivazioneNonIdoneitaFunction = props.showMotivazioneNonIdoneitaFunction;

    const [comuniScuolaFuoriToscana, setComuniScuolaFuoriToscana] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const comuniScuola = [...tuttiComuni].filter(el => ['Emilia-Romagna', 'Lazio', 'Liguria', 'Marche', 'Umbria'].includes(el.denominazione_regione));
        setComuniScuolaFuoriToscana(comuniScuola);
    }, []);

    const printStato = () => {
        switch (card.statoRichiesta?.toLowerCase()) {
            case "bozza":
                return "In bozza";
            case "presentata":
                return "Presentata";
            case "annullata":
                return "Annullata";
            case "non_idonea":
                return "Non idonea";
            case "rinunciata":
                return "Rinunciata";
            case "aggiornata":
            case "aggiornata_terzo_accesso":
                return "Aggiornata";
            case "sospesa":
                return "Sospesa";
            case "contributo_erogato":
                return "Contributo erogato";
            case "ammessa_contributo":
            case "ammessa_contributo_rettificata":
                return "Ammessa al contributo";
            case "non_ammessa_contributo":
                return "Non ammessa al contributo";
            case "revocata":
                return "Revocata";
            default:
                return "";
        }
    };

    const printSVG = () => {
        switch (card.statoRichiesta?.toLowerCase()) {
            case "bozza":
                return "solid--pencil-square";
            case "presentata":
                return "solid--paper-clip";
            case "rifiutata":
                return "solid--no-symbol";
            case "annullata":
                return "solid--x-circle";
            case "aggiornata":
            case "aggiornata_terzo_accesso":
                return "solid--arrow-path";
            case "non_idonea":
                return "solid--x-circle";
            case "rinunciata":
                return "solid--no-symbol";
            case "sospesa":
                return "solid--pause-circle";
            case "contributo_erogato":
                return "solid--currency-euro ";
            case "ammessa_contributo":
            case "ammessa_contributo_rettificata":
                return "solid--hand-thumb-up ";
            case "non_ammessa_contributo":
            case "revocata":
                return "solid--hand-thumb-down ";
            default:
                return "";
        }
    };

    const printColor = () => {
        switch (card.statoRichiesta?.toLowerCase()) {
            case "bozza":
                return "rtds-text-info-dark";
            case "presentata":
                return "rtds-text-secondary-dark";
            case "rifiutata":
                return "rtds-text-error-dark";
            case "non_idonea":
                return "rtds-text-error-dark";
            case "annullata":
                return "rtds-text-error-dark"
            case "contributo_erogato":
                return "rtds-text-success-dark"
            case "ammessa_contributo":
            case "ammessa_contributo_rettificata":
                return "rtds-text-success-dark"
            case "non_ammessa_contributo":
            case "revocata":
                return "rtds-text-error-dark"
            case "sospesa":
                return "rtds-text-warn-dark"
            default:
                return "";
        }
    };

    const showMotivazioneNonIdoneita = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (showMotivazioneNonIdoneitaFunction) {
            showMotivazioneNonIdoneitaFunction(card);
        }
    }

    const eliminaClick = () => {
        if (deleteFunction && card.canBeSaved) {
            deleteFunction(card);
        }
    };

    const rinunciaClick = () => {
        if (renounceFunction && (card.canBeSecondoAccesso || card.canBeTerzoAccesso)) {
            renounceFunction(card);
        }
    }

    const editClick = (e) => {
        console.log("editClick");
        e.stopPropagation();
        e.preventDefault();
        if (editFunction) {
            editFunction(card);
        }
    };

    const aggiornaClick = (e) => {
        console.log("aggiornaClick");
        e.stopPropagation();
        e.preventDefault();
        if (aggiornaFunction) {
            aggiornaFunction(card);
        }
    };

    const secondoAccessoClick = (e) => {
        console.log("secondoAccessoClick");
        e.stopPropagation();
        e.preventDefault();
        if (secondoAccessoFunction) {
            secondoAccessoFunction(card);
        }
    };

    const terzoAccessoClick = (e) => {
        console.log("terzoAccessoClick");
        e.stopPropagation();
        e.preventDefault();
        if (terzoAccessoFunction) {
            terzoAccessoFunction(card);
        }
    };

    const rettificaIbanClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (card.id) {
            navigate('/rettifica-iban', { state: { richiestaId: card.id, iban: "" } });
        }
    };

    const addPdfButton = () => {
        options.push({
            label: "Scarica ricevuta PDF",
            action: () => downloadPdf(),
            icon: "solid--arrow-down-tray",
            key: "download-pdf",
            className: "rtds-btn--s rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--danger rtds-whitespace-nowrap rtds-w-full"
        });
    }

    const options = [];
    switch (card.statoRichiesta?.toLowerCase()) {
        case 'bozza':
            if (card.canBeSaved) {
                options.push({
                    label: "Elimina",
                    action: () => eliminaClick(),
                    icon: "solid--trash",
                    key: "delete",
                    className: "rtds-btn--s rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--danger rtds-whitespace-nowrap rtds-w-full"
                });
            }
            break;
        case 'presentata':
        case 'aggiornata':
            addPdfButton();
            if (card.canBeUndo) {
                options.push({
                    label: "Annulla domanda",
                    action: () => reject(),
                    icon: "solid--x-circle",
                    key: "annulla-domanda",
                    className: "rtds-btn--s rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--danger rtds-whitespace-nowrap rtds-w-full"
                });
            }
            break;
        case 'annullata':
        case 'revocata':
        case 'non_ammessa_contributo':
            addPdfButton();
            break;
        case 'sospesa':
        case 'aggiornata_terzo_accesso':
        case 'rinunciata':
        case 'ammessa_contributo':
        case 'ammessa_contributo_rettificata':
        case 'contributo_erogato':
        case 'non_idonea':

            addPdfButton();
            if (card.canBeSecondoAccesso || card.canBeTerzoAccesso) {
                options.push({
                    label: "Rinuncia",
                    action: () => rinunciaClick(),
                    icon: "solid--trash",
                    key: "rinuncia-domanda",
                    className: "rtds-btn--s rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--danger rtds-whitespace-nowrap rtds-w-full"
                });
            }
            break;
        default:
            break;
    }

    const downloadPdf = async () => {
        if (pdfFunction) {
            pdfFunction(card.id, card.codice);
        }
    }

    const reject = async () => {
        if (rejectFunction) {
            rejectFunction(card.id);
        }
    }

    const printDenominazione = () => card.nomeBeneficiario ? `${card.nomeBeneficiario} ${card.cognomeBeneficiario}` : '';

    const printDate = (field) => {
        return field ? moment(field).format("DD/MM/YYYY HH:mm") : '';
    };

    const printBtnIsee = () => {
        const esitoIsee = card.esitoIsee;
        if (!esitoIsee) return null;
        if (esitoIsee === 'OK') {
            return <>
                <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-02 "></div>
                <div className="">
                    <p

                        className=" rtds-inline-block rtds-whitespace-nowrap rtds-text-success-dark"
                    >
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-mb-1"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use
                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--face-smile`}
                            />
                        </svg>
                        <strong>ISEE valido</strong>
                    </p>
                </div></>;
        }
        const hasTechnicalError = card.erroriIsee && card.erroriIsee.some(errore => errore.tipo === "TECHINCAL");

        if (esitoIsee === 'KO' && !hasTechnicalError) {
            return (<>
                <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-02 "></div>
                <div className="">
                    <button onClick={iseeKoBtnClick}
                        type="button"
                        className="rtds-btn 
                    rtds-btn--icon-left rtds-group/button rtds-btn--warn rtds-btn--s"
                    >
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover/button:-rtds-translate-x-1"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use
                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--face-frown`}
                            />
                        </svg>
                        ISEE non valido
                    </button>
                </div>
            </>);
        }

        return null;
    }

    const iseeKoBtnClick = () => {
        if (iseeKoBtnFunction) iseeKoBtnFunction(card);
    }

    const showRettificaIbanButton = () => {
        const now = moment();
        const inizio = card.faseRettificaIbanDataInizio ? moment(card.faseRettificaIbanDataInizio) : null;
        const fine = card.faseRettificaIbanDataFine ? moment(card.faseRettificaIbanDataFine) : null;

        const isFaseRettificaAperta = (
            inizio &&
            fine &&
            now.isSameOrAfter(inizio) &&
            now.isSameOrBefore(fine)
        );

        const isPagamentoKo = (card.esitoPagamento == 0);

        const isFinanziabileIbanKo = (
            (card.statoRichiesta === 'FINANZIABILE_TERZO_ACCESSO' || card.statoRichiesta === 'FINANZIABILE_RETTIFICATA') &&
            card.checkIbanEsito === 'KO'
        );

        return isFaseRettificaAperta && (isPagamentoKo || isFinanziabileIbanKo);
    };

    return (
        <article
            style={{ minHeight: "250px" }}
            className="rtds-card rtds-card--information rtds-card--information-left-icon rtds-card--horizontal 
      rtds-card--horizontal-left rtds-group/card h-full rtds-flex items-stretch rtds-flex-wrap"
        >
            <div
                className="rtds-content-center rtds-border rtds-rounded-lg rtds-p-2 rtds-border-gray-02 rtds-text-center rtds-grow"
                style={{ width: "120px" }}
            >
                <div className="rtds-card__icon " style={{ margin: "auto" }}>
                    <svg
                        className={`rtds-icon rtds-w-12 rtds-h-12 ${printColor()}`}
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                    >
                        <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${printSVG()}`}
                        />
                    </svg>
                </div>
                <span>{printStato()}
                    {(card.motivazioneNonIdoneita) && (card.statoRichiesta?.toLowerCase() === "non_idonea" ||
                        card.statoRichiesta?.toLowerCase() === "revocata" ||
                        card.statoRichiesta?.toLowerCase() === "non_ammessa_contributo"
                    ) && (
                            <span>&nbsp;
                                <button
                                    type="button"
                                    style={{ verticalAlign: "middle" }}
                                    onClick={showMotivazioneNonIdoneita}
                                    className="rtds-btn rtds-btn--icon rtds-btn--danger rtds-btn--s"
                                >
                                    <svg
                                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                    >
                                        <use
                                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--question-mark-circle`}
                                        />
                                    </svg>
                                    <span className="rtds-sr-only">Button label</span>
                                </button>
                            </span>
                        )}
                </span>
            </div>

            <div className="rtds-card__content rtds-gap-3 sx-grow-4">
                <div className="rtds-flex rtds-justify-between  ">
                    <div>
                        <ul>
                            <li className="rtds-border-b rtds-mb-2 rtds-border-gray-02">
                                Anno Scolastico {card.annoEducativo}
                            </li>
                            <li
                                className="rtds-font-semibold rtds-body-xl"
                                hidden={card.statoRichiesta === 'BOZZA'}
                            >
                                {card.codice}
                            </li>
                            <li className="rtds-body-xs rtds-content-03">
                                <span>Creata il</span>{" "}
                                <time dateTime={card.dataCreazione}>
                                    {printDate(card.dataCreazione)}
                                </time>
                            </li>
                            {printDate(card.dataPresentazione) && (
                                <li className="rtds-body-xs rtds-content-03">
                                    <span>Presentata il</span>{" "}
                                    <time dateTime={card.dataPresentazione}>
                                        {printDate(card.dataPresentazione)}
                                    </time>
                                </li>
                            )}
                            {card.dataAnnullamento && (
                                <li className="rtds-body-xs rtds-content-03">
                                    <span>Annullata il</span>{" "}
                                    <time dateTime={card.dataAnnullamento}>
                                        {printDate(card.dataAnnullamento)}
                                    </time>
                                </li>
                            )}
                            {card.dataAggiornamento && (
                                <li className="rtds-body-xs rtds-content-03">
                                    <span>Rettificata il</span>{" "}
                                    <time dateTime={card.dataAggiornamento}>
                                        {printDate(card.dataAggiornamento)}
                                    </time>
                                </li>
                            )}
                            {(card.dataAggiornamentoSecondoAccesso || card.dataAggiornamentoTerzoAccesso) && (
                                <li className="rtds-body-xs rtds-content-03">
                                    <span>Aggiornata il</span>{" "}
                                    <time dateTime={card.dataAggiornamentoTerzoAccesso ?? card.dataAggiornamentoSecondoAccesso}>
                                        {printDate(card.dataAggiornamentoTerzoAccesso ?? card.dataAggiornamentoSecondoAccesso)}
                                    </time>
                                </li>
                            )}
                            {(card.dataRettificaIban) && (
                                <li className="rtds-body-xs rtds-content-03">
                                    <span>Rettificato IBAN il</span>{" "}
                                    <time dateTime={card.dataRettificaIban}>
                                        {printDate(card.dataRettificaIban)}
                                    </time>
                                </li>
                            )}
                            {card.dataRinuncia && (
                                <li className="rtds-body-xs rtds-content-03">
                                    <span>Rinunciata il</span>{" "}
                                    <time dateTime={card.dataRinuncia}>
                                        {printDate(card.dataRinuncia)}
                                    </time>
                                </li>
                            )}
                        </ul>
                        {printDate(card.numeroProtocollo) && (
                            <>
                                <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-02 rtds-mt-2 rtds-mb-2 "></div>
                                <ul>
                                    <li className="rtds-body-xs rtds-content-03 ">
                                        <span>Numero Protocollo</span>{" "}
                                        <span className="rtds-font-semibold">
                                            {card.numeroProtocollo}
                                        </span>
                                    </li>

                                    {printDate(card.dataProtocollo) && (
                                        <li className="rtds-body-xs rtds-content-03">
                                            <span>Protocollata il</span>{" "}
                                            <time dateTime={card.dataProtocollo}>
                                                {printDate(card.dataProtocollo)}
                                            </time>
                                        </li>
                                    )}
                                </ul>
                            </>
                        )}
                    </div>

                    <Dropdown options={options} />
                </div>

                {printDenominazione() && (
                    <div className="rtds-card__heading">
                        <h3 className="rtds-card__title">{printDenominazione()}</h3>
                    </div>
                )}

                {
                    card.istitutoInToscana === false
                        ? (
                            <div className="rtds-card__description rtds-text-neutral-800">
                                <div className="rtds-inline-block">
                                    <ul>
                                        <li>
                                            Regione: {card.regioneScuolaFuoriToscana}
                                        </li>
                                        <li className="rtds-border-b rtds-mb-2 rtds-border-gray-02">
                                            Comune: {comuniScuolaFuoriToscana.find(el => el.id === parseInt(card.comuneFuoriToscanaId))?.denominazione}
                                        </li>
                                        <li>{card.denominazioneScuolaFuoriToscana}</li>
                                        <li>Codice: {card.codiceScuolaFuoriToscana}</li>
                                    </ul>
                                </div>
                            </div>
                        )
                        : card.denominazionePlesso
                            ? (
                                <div className="rtds-card__description rtds-text-neutral-800">
                                    <div className="rtds-inline-block">
                                        <ul>
                                            <li className="rtds-border-b rtds-mb-2 rtds-border-gray-02">
                                                Scuola {card.tipologiaPlesso}
                                            </li>
                                            <li>{card.denominazionePlesso}</li>
                                            <li>Codice: {card.codicePlesso}</li>
                                        </ul>
                                    </div>
                                </div>
                            )
                            : (
                                ""
                            )
                }
                {printBtnIsee()}

                {/* <ul className="rtds-card__tags" aria-label="Categorie">
                    <li>
                        <span className="rtds-chip rtds-chip--category">
                            <span className="rtds-sr-only">Categoria: </span>
                            2° accesso
                        </span>
                    </li>

                    <li>
                        <span className="rtds-chip rtds-chip--category">
                            <span className="rtds-sr-only">Categoria: </span>
                            3° accesso
                        </span>
                    </li>
                </ul> */}

                <div className="rtds-space-y-2 rtds-ml-3 md:rtds-space-y-0 md:rtds-flex md:rtds-items-baseline md:rtds-justify-between md:rtds-gap-2">
                    <span
                        className="rtds-btn rtds-block rtds-btn--icon-right rtds-group/button rtds-btn--only-text rtds-btn--s"
                    >
                        <a
                            onClick={editClick}
                            hidden={card.canBeUpdated || card.canBeSecondoAccesso || card.canBeTerzoAccesso}
                            className="rtds-btn rtds-btn--only-text"
                            href="#"
                        >
                            {card.statoRichiesta?.toLowerCase() === "bozza" && card.canBeSaved
                                ? "Compila"
                                : "Dettaglio"}
                            <svg
                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                            >
                                <use
                                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                />
                            </svg>
                        </a>
{/*
                        <a
                            hidden={
                                (card.statoRichiesta?.toLowerCase() !== "presentata" &&
                                    card.statoRichiesta?.toLowerCase() !== "aggiornata") ||
                                !card.canBeUpdated
                            }
                            onClick={aggiornaClick}
                            className="rtds-btn rtds-btn--only-text"
                            href="#"
                        >
                            Rettifica
                            <svg
                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                            >
                                <use
                                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                />
                            </svg>
                        </a>
*/}
                        <a
                            onClick={secondoAccessoClick}
                            hidden={
                                (
                                    card.statoRichiesta?.toLowerCase() !== "presentata" &&
                                    card.statoRichiesta?.toLowerCase() !== "aggiornata" 
                                ) ||
                                !card.canBeSecondoAccesso
                            }
                            className="rtds-btn rtds-btn--only-text"
                            href="#"
                        >
                            Aggiorna
                            <svg
                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                            >
                                <use
                                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                />
                            </svg>
                        </a>
                        {<a
                            onClick={terzoAccessoClick}
                            hidden={
                                (
                                    
                                    !(card.statoRichiesta?.toLowerCase() === "sospesa" ||
                                    card.statoRichiesta?.toLowerCase() === "aggiornata_terzo_accesso" )
                                ) ||
                                !card.canBeTerzoAccesso
                            }
                            className="rtds-btn rtds-btn--only-text"
                            href="#"
                        >
                            Aggiorna
                            <svg
                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                            >
                                <use
                                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                />
                            </svg>
                        </a>
}
                    </span>
                </div>
                <div className="rtds-space-y-2 rtds-ml-3 md:rtds-space-y-0 md:rtds-flex md:rtds-items-baseline md:rtds-justify-between md:rtds-gap-2">
                    <span className="rtds-btn rtds-block rtds-btn--icon-right rtds-group/button rtds-btn--only-text rtds-btn--s">
                        <a
                            onClick={rettificaIbanClick}
                            hidden={!showRettificaIbanButton()}
                            className="rtds-btn rtds-btn--only-text rtds-block"
                            href="#"
                        >
                            {"Rettifica IBAN"}
                            <svg
                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                aria-hidden="true"
                                focusable="false"
                                role="img"
                            >
                                <use
                                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                />
                            </svg>
                        </a>
                    </span>
                </div>
            </div>
        </article>
    );
};

export default Card;
